import {FC} from 'react'
import {Content} from '@prismicio/client'
import {SliceComponentProps} from '@prismicio/react'
import {AnimatedListDefault} from './DefaultVariation'
import {AnimatedListContainerVariation} from './ContainerVariation'

/**
 * Props for `AnimatedList`.
 */
export type AnimatedListProps = SliceComponentProps<Content.AnimatedListSlice>

/**
 * Component for "AnimatedList" Slices.
 */
const AnimatedList: FC<AnimatedListProps> = ({slice}) => {
  switch (slice.variation) {
    case 'default':
      return <AnimatedListDefault slice={slice} />
    case 'withContainer':
      return <AnimatedListContainerVariation slice={slice} />
    default:
      return <></>
  }
}

export default AnimatedList
